import { IInvoice, IShift } from 'models';
import { IDashboardSummary } from 'models/dashboard';
import moment from 'moment';
import { GetContactName } from 'redux/actions/contacts';
import { ECrudType } from 'redux/actions/crud';
import { EActions } from 'redux/actions/EActions';
import { GetReducer, ICrudState } from './crud';

export interface IDashboardState extends ICrudState {
  isLoadingToday: boolean;
  isLoadingPending: boolean;
  isLoadingNotInvoiced: boolean;
  isLoadingOverdue: boolean;
  today?: IShift[];
  pending?: IShift[];
  notInvoiced?: IShift[];
  overdue?: IInvoice[];
  summary?: IDashboardSummary;
}

const dashboardReducer = GetReducer(
  ECrudType.dashboard,
  (obj: any) => {
    return {
      ...obj,
      date: moment(obj.date),
      dueDate: moment(obj.dueDate),
      contact: {
        ...obj.contact,
        name: GetContactName(obj.contact),
      },
    };
  },
  undefined,
  (state: any, action: any) => {
    switch (action.type) {
      case ECrudType.dashboard + '_TODAY' + EActions.CRUD_LOADING:
        return {
          ...state,
          isLoadingToday: true,
        };
      case ECrudType.dashboard + '_TODAY':
        return {
          ...state,
          isLoadingToday: false,
          today: action.payload,
        };
      case ECrudType.dashboard + '_PENDING':
        return {
          ...state,
          isLoadingPending: false,
          pending: action.payload,
        };
      case ECrudType.dashboard + '_PENDING' + EActions.CRUD_LOADING:
        return {
          ...state,
          isLoadingPending: true,
        };
      case ECrudType.dashboard + '_NOT_INVOICED':
        return {
          ...state,
          isLoadingNotInvoiced: false,
          notInvoiced: action.payload,
        };
      case ECrudType.dashboard + '_NOT_INVOICED' + EActions.CRUD_LOADING:
        return {
          ...state,
          isLoadingNotInvoiced: true,
        };
      case ECrudType.dashboard + '_OVERDUE':
        return {
          ...state,
          isLoadingOverdue: false,
          overdue: action.payload,
        };
      case ECrudType.dashboard + '_OVERDUE' + EActions.CRUD_LOADING:
        return {
          ...state,
          isLoadingOverdue: true,
        };
      case ECrudType.dashboard + '_SUMMARY':
        return {
          ...state,
          isLoading: false,
          summary: action.payload,
        };
    }
  },
);

export default dashboardReducer;
